var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2665_1768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 3C4.6665 3 1.81984 5.07333 0.666504 8C1.81984 10.9267 4.6665 13 7.99984 13C11.3332 13 14.1798 10.9267 15.3332 8C14.1798 5.07333 11.3332 3 7.99984 3ZM7.99984 11.3333C6.15984 11.3333 4.6665 9.84 4.6665 8C4.6665 6.16 6.15984 4.66667 7.99984 4.66667C9.83984 4.66667 11.3332 6.16 11.3332 8C11.3332 9.84 9.83984 11.3333 7.99984 11.3333ZM7.99984 6C6.89317 6 5.99984 6.89333 5.99984 8C5.99984 9.10667 6.89317 10 7.99984 10C9.1065 10 9.99984 9.10667 9.99984 8C9.99984 6.89333 9.1065 6 7.99984 6Z",
    fill: "#137A83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2665_1768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEye);
export default __webpack_public_path__ + "static/media/view-eye.ea25a472044af9ed42a42428e67b84d0.svg";
export { ForwardRef as ReactComponent };